<crm-document-form
  *ngIf="(loading$ | async) === false"
  [isModal]="true"
  [index]="index"
  [canDelete]="(form$ | async)?.isEdit"
  [document]="document"
  [companies]="companies"
  [directions]="directions"
  [nds]="nds"
  [bankDetails]="bankDetails"
  (bankDetailsSearch)="searchBankDetails($event)"
  (createBasedOnClick)="createBasedOn()"
  [canCreateBasedOn]="
    (form$ | async)?.isEdit &&
    document.documentType?.sync1c === false &&
    !document.basedOnDocument &&
    !document.spawnedDocument
  "
  [canCreateCopyOn]="(form$ | async)?.isEdit && document.documentType?.sync1c === false"
  [canCreateTemplate]="(form$ | async)?.isEdit && document.documentType?.sync1c === false"
  (save)="saveDocument($event)"
  (delete)="deleteDocument()"></crm-document-form>

<crm-spinner *ngIf="loading$ | async"></crm-spinner>
